import React, { useEffect, useState, useRef } from 'react'

import { ScrollView, View, StyleSheet, Keyboard, TouchableOpacity, Text, Linking } from 'react-native'
import delay from 'delay'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  Price,
  Space,
  KeyboardAvoidingView,
  Button,
  AnimatedEllipsis,
  ProductListItem,
  TextInput
} from '@sart/components'
import { adaptive, backgroundColors, colors, typography, radius } from '@sart/styles'
import client, { orderHelper, useData } from '@sart/client'
import { useContent } from '@sart/content'

import ApiClient from "../bff-client/src/ApiClient";
import BasketsApi from "../bff-client/src/api/BasketsApi";
import ProductsApi from "../bff-client/src/api/ProductsApi";
import CustomersApi from "../bff-client/src/api/CustomersApi";
import AppConfig from '../Configuration/AppConfig';
import discountsHelper from '../util/discountsHelper';
import * as theme from '../Sign/signTheme'
import { testID } from '@sart/utilities'
import { Link } from '@react-navigation/native'


export default function ChangePlanReview(props) {
  const { navigation, route } = props
  const newPlan = route.params?.newPlan
  const currentPlan = route.params?.currentPlan
  const [promoCode, setPromoCode] = useState('')
  const [basket, setBasket] = useState(null)
  const [validationError, setValidationError] = useState('')
  const [discountDisplay, setDiscountDisplay] = useState('')
  const [discountValidated, setDiscountValidated] = useState(false)
  const [discountProcessing, setDiscountProcessing] = useState(false)
  const [discountProduct, setDiscountProduct] = useState(null)

  const [{ loading, error }, setData] = useData({ loading: false })

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl,
  }
  const basketsApi = new BasketsApi(bffClient)
  const productsApi = new ProductsApi(bffClient)
  const customersApi = new CustomersApi(bffClient)

  const {
    customer,
    user,
    serviceId,
    accountId,
    token
  } = client.cache

  console.log('accountId: ' + accountId)
  console.log('serviceId: ' + serviceId)

  const content = useContent()

  useEffect(() => {
    if (!discountProduct) {
      getDiscountProduct();
    }
  }, []);

  function getRecurringString(product) {
    var toReturn
    // Use the frequency to work out if we use 'per' or 'every x'
    if (product.recurringFrequency === 1) {
      toReturn = content.product.per
    } else if (product.recurringFrequency > 1) {
      toReturn = content.product.every + product.recurringFrequency
    }
    //Use frequency unit to work out how often it recurs 
    if (product.recurringFrequencyUnit.toUpperCase() === 'DAYS') {
      toReturn = toReturn + content.product.days
    } else if (product.recurringFrequencyUnit.toUpperCase() === 'WEEKS') {
      toReturn = toReturn + content.product.weeks
    } else if (product.recurringFrequencyUnit.toUpperCase() === 'MONTHS') {
      toReturn = toReturn + content.product.months
    }
    // If the frequency is 1, make the postfix singular
    if (product.recurringFrequency === 1 && toReturn) {
      toReturn = toReturn?.substring(0, toReturn.length - 1)
    }
    return toReturn
  }

  async function getDiscountProduct() {
    const discountProducts = await productsApi.productsGet({ "category": "modifyservicedetails" });
    const discountProduct = discountProducts.find(p => p.legacyId === AppConfig.applyDiscountProduct);
    setDiscountProduct(discountProduct);
    return discountProduct;
  }



  async function applyOrRemoveDiscount() {

    setDiscountProcessing(true);
    setValidationError(null);

    if (discountValidated) {
      //already have a discount applied, so remove it
      setPromoCode("");
      setDiscountDisplay("");
      setDiscountValidated(false);
    } else {
      //apply discount
      try {
        console.log('discount not yet validated, so adding it');

        console.log('discount product is: ' + JSON.stringify(discountProduct, null, 2));

        if (!discountProduct) {
          await getDiscountProduct();
        }

        //trim any leading or trailing whitespace from the code
        console.log('username is: ' + customer.user.userName);
        const discountExtendedData = {
          promoCode: promoCode?.trim(),
          emailAddress: customer.user.userName
        }
        console.log('discountExtendedData: ' + JSON.stringify(discountExtendedData, null, 2));

        const serviceItems = [{ productId: newPlan.productId }, { productId: discountProduct.id, extendedData: discountExtendedData }];

        const basketsPostRequest = {
          serviceItems: serviceItems,
          channel: AppConfig.channelName
        }

        console.log('basketsPostRequest: ' + JSON.stringify(basketsPostRequest, null, 2));

        const basket = await basketsApi.basketsPost({ basketsPostRequest });
        console.log('validating basket: ' + JSON.stringify(basket, null, 2));
        const validationResponse = await basketsApi.basketsValidatePost(basket);
        console.log("validationResponse: " + JSON.stringify(validationResponse, null, 2));

        //any successful non-error response means validation has passed according to the API doc
        setDiscountValidated(true);
        setDiscountDisplay(validationResponse.coupon)

      } catch (error) {
        console.log("Error validating discount: " + JSON.stringify(error, null, 2));
        if (error.body?.validationErrors?.length > 0 && error.body?.validationErrors[0]?.errors?.length > 0) {
          const errorCode = discountsHelper.getHighestPriorityErrorCode(error.body?.validationErrors[0]?.errors);
          console.log("errorCode: " + errorCode);
          const errorMessage = content.errors.promoCodeErrors[errorCode] || "Other Problem";
          setValidationError(errorMessage);
        } else {
          setValidationError('Invalid Discount Code');
        }
        setDiscountValidated(false);
      }
    }
    setDiscountProcessing(false);
  }


  async function handleSubmit() {
    Keyboard.dismiss()
    console.log("Submitting change plan ");

    setData({ loading: true, error: null })
    try {

      const email = customer.user.userName
      let changePlanProduct, extendedData, order
      console.log('currentPlan: ' + JSON.stringify(currentPlan, null, 2))

      if (currentPlan) {
        const changePlanProducts = await client.callApi('catalog', 'getModifyServiceDetailsProducts', [client.cache.catalogId])
        changePlanProduct = changePlanProducts.find(product => product.productLegacyId === AppConfig.changePlanProduct)
        extendedData = {
          emailAddress: email,
          currentBundleName: currentPlan.product.productLegacyId,
          newBundleName: newPlan.productLegacyId,
          newProductId: newPlan.productId,
          promoCode: discountValidated ? promoCode?.trim() : undefined,
        }
        console.log("extendedData is: " + JSON.stringify(extendedData, null, 2));
        order = await client.checkoutServiceProduct(changePlanProduct, extendedData, 'noPayment')
      } else {
        console.log('submitting a new plan purchase')
        bffClient.defaultHeaders['Authorization'] = `Bearer ${token}`;

        const customersIdNewPlanPostRequest = {
          "productId": newPlan.productId,
          "accountId": accountId,
          "serviceId": serviceId,
          "promoCode": discountValidated ? promoCode?.trim() : undefined,
        }
        console.log("customersIdNewPlanPostRequest is: " + JSON.stringify(customersIdNewPlanPostRequest, null, 2));

        const changePlanResult = await customersApi.customersIdNewPlanPost(customer.customerId, customersIdNewPlanPostRequest);
        console.log("changePlanResult is: " + JSON.stringify(changePlanResult, null, 2));
        if (changePlanResult && changePlanResult.gatewayURL) {
          Linking.openURL(changePlanResult.gatewayURL);
          return;
        }
        // if (discountValidated) {
        //   let basket
        //   basket = await client.createBasket()
        //   basket = await client.addServiceProductToBasket(basket, newPlan, undefined)

        //   discountProduct.productId = discountProduct.id;
        //   const discountExtendedData = {
        //     promoCode: promoCode?.trim(),
        //     emailAddress: customer.user.userName
        //   }
        //   basket = await client.addServiceProductToBasket(basket, discountProduct, discountExtendedData)
        //   basket = await client.confirmBasket(basket)
        //   order = await client.processConfirmedBasketNoPayment(basket)
        //   console.log("Order response is: " + JSON.stringify(order, null, 2));
        //   if (order && order.status !== 'successful' || order.status !== 'failed') {
        //     order = await client.pollOrderForStatus(customer.customerId, order.orderId)
        //     console.log('order after polling: ' + JSON.stringify(order, null, 2));
        //   }

        //   //Call the BFF to change the plan, then open the stripe gateway that comes back in the response

        // } else {
        //   //No discount to consider, just send the plan through in a basket/order
        //   changePlanProduct = newPlan
        //   extendedData = undefined
        //   order = await client.checkoutServiceProduct(changePlanProduct, extendedData, 'noPayment')
        // }


      }
      console.log("Order response is: " + JSON.stringify(order, null, 2));

      if (order && order.status === 'successful') {

        let confirmationText, params

        if (currentPlan) {
          confirmationText = 'You have successfully submitted your plan change from ' + currentPlan.product.productName + ' to ' + newPlan.productName + '. This will take effect on your next renewal date.'
          params = {
            confirmation: {
              title: 'Change Plan Submitted',
              description: confirmationText,
            }
          }
        } else {
          //update the BFF here to set the auto-renew flag to ON for new plan purhcases, we can do this asynchronously
          //as we're not bothered about the response for now
          customersApi.updateSubscription({ email: customer.user.userName, autoRenew: true })
          confirmationText = 'You have successfully submitted your plan purchase of ' + newPlan.productName + '. This should reflect on your account shortly.'
          params = {
            confirmation: {
              title: 'Plan Purchase Successful',
              description: confirmationText,
            }
          }
        }

        navigation.navigate('Confirmation', params)

      } else {
        setData({ loading: false, error: 'Change Plan failed, please try again later' })
      }


      setData({ loading: false })


    } catch (error) {
      console.log(error);
      // const message = prettyErrorMessage(error)

      // form.setFieldError('gender', message)
      setData({ loading: false, error: 'Change Plan failed, please try again later' })
    }
  }


  return (
    <KeyboardAvoidingView style={styles.container}>
      <ScrollView contentContainerStyle={{ height: '100%', width: '100%', alignItems: 'center' }}
      // ref={scrollViewRef}
      >
        <View style={styles.widthRestrictions}>
          {!currentPlan &&
            <>
              <Text style={styles.descriptionStyle}>Please confirm that you would like to purchase the plan </Text>

              <Space height={16} />

              <Text style={styles.descriptionStyle}>{newPlan.productName}</Text>
            </>
          }
          {currentPlan &&
            <>
              <Text style={styles.descriptionStyle}>You currently have the following plan</Text>

              <Space height={24} />

              <ProductListItem
                disabled={true}
                product={currentPlan.product}
                priceStyle={styles.price}
                placeholderStyle={styles.productStyle}
                bodyStyle={styles.body}
                imageColor={colors.white}
                // language={language}
                injectedContent={content}
              />

              <Space height={24} />

              <Text style={styles.descriptionStyle}>Please confirm you would like to switch to </Text>

              <Space height={24} />

              <ProductListItem
                disabled={true}
                product={newPlan}
                priceStyle={styles.price}
                placeholderStyle={styles.productStyle}
                bodyStyle={styles.body}
                imageColor={colors.white}
                // language={language}
                injectedContent={content}
              />

              <Space height={24} />

              <Text style={styles.descriptionStyle}>on your next renewal date?</Text>
              <Space height={24} />
              <Text style={styles.subtext}>{content.manage_plan.terms}</Text>

            </>
          }
          <Space height={12} />


          <View style={{ flexDirection: 'row', alignItems: 'center', width: '100%' }}>
            <View style={{ flex: 3, marginRight: 16 }}>
              <TextInput
                label={content.forms.promoCodeLabel}
                placeholder={content.forms.promoCodePlaceholder}
                value={promoCode}
                onChangeText={setPromoCode}
                // onBlur={() => { }}
                // error={form.touched.promoCode && form.errors.promoCode}
                {...theme.textInput}
                autoCapitalize="characters"
                autoCorrect={false}
                disabled={discountValidated}
                {...testID('promoCode')}
              />
            </View>
            <View style={{ flex: 2 }}>
              <Button
                title={discountValidated ? 'Remove' : 'Apply'}
                onPress={applyOrRemoveDiscount}
                style={styles.enabled}
                disabledStyle={styles.disabled}
                titleStyle={{ ...typography.bold, fontSize: 12, color: colors.white }}
                disabledTitleStyle={{ ...typography.bold, fontSize: 12, color: colors.white + 45 }}
                disabled={discountProcessing}
                {...testID('applyPromoCode')}
              />
            </View>
          </View>

          {validationError &&
            <Text style={styles.errorText}>
              {validationError}
            </Text>
          }

          {discountValidated && discountDisplay &&
            <Text style={styles.discountText}>
              {content.discounts.discountCodeAppliedMessage(discountDisplay.name)}
            </Text>
          }

          <Space height={12} />

          {error &&
            <Text style={styles.errorText}>
              {error}
            </Text>
          }

          <Button
            title={
              loading
                ? <AnimatedEllipsis style={{ fontSize: 24, color: colors.clear, ...typography.extrabold }} />
                : content.common.submit
            }
            onPress={handleSubmit}
            style={styles.enabled}
            disabledStyle={styles.disabled}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
            {...testID('changeplanSubmit')}
          />
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  dateStyle: {
    fontSize: 16,
    lineHeight: 22,
    color: colors.white,
    ...typography.demi
  },
  planContainer: {
    padding: 12,
    backgroundColor: backgroundColors.darkCharcoal,
    borderRadius: radius.medium,
    elevation: 8,
    // ...shadows.shadowByElevation(8),
    borderColor: colors.white,
    borderWidth: 1
  },
  planStyle: {
    fontSize: 20,
    lineHeight: 48,
    fontWeight: '700',
    color: colors.brightOrange
  },
  descriptionStyle: {
    fontSize: 16,
    lineHeight: 16,
    color: colors.white,
    ...typography.lightbold,
  },
  subtext: {
    fontSize: 14,
    lineHeight: 14,
    color: colors.subtle,
  },
  descriptionnNoPlanStyle: {
    fontSize: 16,
    lineHeight: 16,
    color: colors.srTextInput,
    ...typography.demi,
  },
  descriptionContentStyle: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.white,
    ...typography.demi
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  discountText: {
    paddingTop: 8,
    fontSize: 12,
    lineHeight: 20,
    color: colors.white,
    ...typography.demi,
  },
  selectStyle: {
    ...typography.demi
  },
  curpFooter: {
    ...typography.demi,
    color: colors.brightOrange,
    alignContent: 'flex-end',
    textDecorationLine: 'underline'
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 1
  },
  inputStyle: {
    height: 300
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  label: {
    color: colors.brightOrange,
    ...typography.lightbold,
    fontSize: 16
  },
  helpIcon: {
    justifyContent: 'center'
  },
  helpPointContainer: {
  },
  helpPointText: {
    ...typography.medium,
    color: colors.brightOrange,
    fontSize: 14
  },
  noId: {
    ...typography.demi,
  },
  labelStyles: {
    color: colors.brightOrange,
    ...typography.demi
  },
  smallButton: {
    backgroundColor: colors.brightOrange,
    fontSize: 12
  },
  enabled: {
    backgroundColor: colors.brightOrange,
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    borderColor: colors.brightOrange + 60,
    borderWidth: 1
  },
  subTitle: {
    ...typography.lightbold,
    color: colors.white
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  },
  textInput: {
    backgroundColor: colors.white
  },
  errorText: {
    color: 'red',
    marginTop: 8,
    marginBottom: 8,
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi
  })
};